const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoInteractions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.62,248.65c2-25.29-4.16-51.71-12.39-75.25-12.22-35-36-70.84-75.93-79.12-23.05-4.77-46.51.35-66.27,12.31-19,11.5-33.83,26.36-57.19,29.24-23.63,2.91-47.88,1.73-71.64,1.73C111.13,137.56,61.56,199,74,263S144.76,371.4,194.33,371.4c44.55,0,81.19-25.59,123.5-32.46,21-3.41,42.05.62,62.81-4.48,24.13-5.94,46.82-20.1,60.19-40.6C449.94,279.88,454.38,264.49,455.62,248.65Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.62,248.65c2-25.29-4.16-51.71-12.39-75.25-12.22-35-36-70.84-75.93-79.12-23.05-4.77-46.51.35-66.27,12.31-19,11.5-33.83,26.36-57.19,29.24-23.63,2.91-47.88,1.73-71.64,1.73C111.13,137.56,61.56,199,74,263S144.76,371.4,194.33,371.4c44.55,0,81.19-25.59,123.5-32.46,21-3.41,42.05.62,62.81-4.48,24.13-5.94,46.82-20.1,60.19-40.6C449.94,279.88,454.38,264.49,455.62,248.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "207.82 80.3 204.09 70.98 143.53 70.98 143.53 80.3 143.53 110.25 143.53 329.22 380.46 329.22 380.46 80.3 207.82 80.3",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.85,
    y: 86.29,
    width: 228.95,
    height: 240.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.85,
    y: 86.29,
    width: 228.95,
    height: 9.98,
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,106.72H222.86a6.38,6.38,0,0,0-6.38,6.39v34.3l7.55-8h82.58A6.39,6.39,0,0,0,313,133V113.11A6.39,6.39,0,0,0,306.61,106.72Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.57,
    cy: 120.76,
    r: 8.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,120.15s.94-1.26,1.15,0-1.61,2.82-1.61,2.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.07,120.15s-.94-1.26-1.15,0,1.61,2.82,1.61,2.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.9,114s-3.55-.28-4.37,2.09a14.4,14.4,0,0,0,0,6.92c.27.73,2.55,4.28,3.19,4.56a3.15,3.15,0,0,0,2.46-.19c.27-.36,2.55-3.73,2.73-4.91a46.27,46.27,0,0,0-.1-5.22,3.25,3.25,0,0,0-2-2.83A5.87,5.87,0,0,0,233.9,114Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,117.21a3.25,3.25,0,0,0-2-2.83,5.87,5.87,0,0,0-1.91-.42s-3.55-.28-4.37,2.09a11.46,11.46,0,0,0-.4,4.16c.17.21.77.84.68,0s-.21-3.77.52-4.39.84-1.16,1.88-.32.95,1.57,2,1,1.26-1.68,2.2-1.26.63,2.41.63,3.35,0,2.72.63,1.89a2.74,2.74,0,0,0,.28-.57C237.91,119,237.85,118,237.81,117.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 114.35,
    x2: 266.44,
    y2: 114.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 120.83,
    x2: 304.77,
    y2: 120.83,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 126.18,
    x2: 304.77,
    y2: 126.18,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 132.1,
    x2: 304.77,
    y2: 132.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,241.51H222.86a6.37,6.37,0,0,0-6.38,6.38v34.3l7.55-8h82.58a6.39,6.39,0,0,0,6.39-6.38V247.89A6.38,6.38,0,0,0,306.61,241.51Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.57,
    cy: 255.55,
    r: 8.98,
    transform: "matrix(0.73, -0.69, 0.69, 0.73, -111.65, 229.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,254.93s.94-1.26,1.15,0-1.61,2.83-1.61,2.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.07,254.93s-.94-1.26-1.15,0,1.61,2.83,1.61,2.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.9,248.74s-3.55-.27-4.37,2.09a14.44,14.44,0,0,0,0,6.93c.27.72,2.55,4.28,3.19,4.55a3.19,3.19,0,0,0,2.46-.18c.27-.37,2.55-3.74,2.73-4.92a46.27,46.27,0,0,0-.1-5.22,3.27,3.27,0,0,0-2-2.83A6.14,6.14,0,0,0,233.9,248.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,252a3.27,3.27,0,0,0-2-2.83,6.14,6.14,0,0,0-1.91-.42s-3.55-.27-4.37,2.09a11.46,11.46,0,0,0-.4,4.16c.17.21.77.85.68,0s-.21-3.77.52-4.4.84-1.15,1.88-.32.95,1.58,2,1.05,1.26-1.67,2.2-1.25.63,2.4.63,3.35,0,2.72.63,1.88a2.51,2.51,0,0,0,.28-.57C237.91,253.82,237.85,252.79,237.81,252Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 249.13,
    x2: 266.44,
    y2: 249.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 255.61,
    x2: 304.77,
    y2: 255.61,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 260.97,
    x2: 304.77,
    y2: 260.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 266.89,
    x2: 304.77,
    y2: 266.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,197.15H267.28a6.38,6.38,0,0,0-6.38,6.38v19.92a6.38,6.38,0,0,0,6.38,6.38h82.59l7.55,8v-34.3A6.38,6.38,0,0,0,351,197.15Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 211.19,
    r: 8.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.52,210.57s1-1.25,1.15,0-1.6,2.83-1.6,2.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5,210.57s-.94-1.25-1.15,0S274,213.4,274,213.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.33,204.38s-3.55-.27-4.37,2.09a14.31,14.31,0,0,0,0,6.93c.27.72,2.55,4.28,3.18,4.55a3.19,3.19,0,0,0,2.46-.18c.28-.37,2.55-3.74,2.73-4.92a42,42,0,0,0-.1-5.22,3.25,3.25,0,0,0-2-2.83A6,6,0,0,0,278.33,204.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.23,207.63a3.25,3.25,0,0,0-2-2.83,6,6,0,0,0-1.9-.42s-3.55-.27-4.37,2.09a11.69,11.69,0,0,0-.41,4.16c.18.21.77.85.68.05-.1-1-.21-3.77.53-4.4s.83-1.15,1.88-.31.94,1.57,2,1,1.26-1.67,2.2-1.25.63,2.4.63,3.35,0,2.72.62,1.88a2.15,2.15,0,0,0,.28-.57C282.33,209.47,282.28,208.43,282.23,207.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76,206.28a5,5,0,0,0,3.54,2.15,5.12,5.12,0,0,0,3.93-.8s1.14,0,1.14-1.35.38-.78-1.56-.78S275.28,201.88,274.76,206.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,211.15h-3.53l.38,1.17a.55.55,0,0,0,.52.38h1.82a.55.55,0,0,0,.53-.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.77,211.15h-3.53l.38,1.17a.55.55,0,0,0,.52.38H281a.54.54,0,0,0,.53-.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.26,
    y1: 204.77,
    x2: 310.86,
    y2: 204.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.26,
    y1: 211.25,
    x2: 349.19,
    y2: 211.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.26,
    y1: 216.61,
    x2: 349.19,
    y2: 216.61,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.26,
    y1: 222.53,
    x2: 349.19,
    y2: 222.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.8,153.8H224.05a6.39,6.39,0,0,0-6.39,6.39v34.3l7.55-8H307.8a6.38,6.38,0,0,0,6.38-6.38V160.19A6.38,6.38,0,0,0,307.8,153.8Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.36,
    cy: 170.31,
    r: 8.98,
    transform: "translate(-24.99 41.2) rotate(-9.54)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,163.49a3.41,3.41,0,0,0-4.49,2c-1.23,3.25.31,7.73.31,9.58s1.86,3.41,3.87,3.56,4.64.46,6.18-2,.93-7.88.31-11S235.39,163.33,233.23,163.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,169.69s1-1.26,1.16,0-1.61,2.83-1.61,2.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,169.69s-.94-1.26-1.15,0,1.61,2.83,1.61,2.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,163.5s-3.55-.27-4.37,2.09a14.31,14.31,0,0,0,0,6.93c.27.72,2.55,4.28,3.18,4.55a3.19,3.19,0,0,0,2.46-.18c.28-.37,2.55-3.74,2.74-4.92a46.27,46.27,0,0,0-.1-5.22,3.28,3.28,0,0,0-2-2.83A6,6,0,0,0,234.69,163.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,164.42s5.74,5.27,6.89,5.27,1.3-3.88.07-5.74S231.84,161,232,164.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.92,
    y1: 160.83,
    x2: 266.52,
    y2: 160.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.92,
    y1: 167.31,
    x2: 304.85,
    y2: 167.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.92,
    y1: 172.66,
    x2: 304.85,
    y2: 172.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.92,
    y1: 178.58,
    x2: 304.85,
    y2: 178.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.9,
    y: 105.4,
    width: 35.4,
    height: 218.86,
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.63,
    cy: 168.44,
    r: 11.33,
    transform: "translate(-63.86 182.72) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,159.84s-4.1-1.56-5.66,2.54.39,9.75.39,12.09,2.34,4.29,4.88,4.49,5.85.58,7.8-2.54,1.17-9.95.39-13.85S189.94,159.64,187.21,159.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,167.66s1.19-1.58,1.46,0-2,3.57-2,3.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,167.66s-1.19-1.58-1.46,0,2,3.57,2,3.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,159.85s-4.48-.34-5.52,2.64-.34,7.82,0,8.74,3.22,5.4,4,5.74,2.76.23,3.11-.23,3.22-4.71,3.44-6.2A54.86,54.86,0,0,0,194,164a4.12,4.12,0,0,0-2.53-3.57A7.68,7.68,0,0,0,189.05,159.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.65,161s7.24,6.65,8.69,6.65,1.64-4.89.08-7.24S185.45,156.72,185.65,161Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.63,
    cy: 130.41,
    r: 11.33,
    transform: "translate(-24.82 46.58) rotate(-13.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,129.63s1.19-1.59,1.46,0-2,3.56-2,3.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,129.63s-1.19-1.59-1.46,0,2,3.56,2,3.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,121.82s-4.48-.35-5.52,2.64-.34,7.81,0,8.73,3.22,5.4,4,5.75,2.76.23,3.11-.23,3.22-4.71,3.44-6.21a54.72,54.72,0,0,0-.12-6.58,4.1,4.1,0,0,0-2.53-3.57A7.41,7.41,0,0,0,189.05,121.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,125.92a4.1,4.1,0,0,0-2.53-3.57,7.41,7.41,0,0,0-2.4-.53s-4.48-.35-5.52,2.64a14.69,14.69,0,0,0-.51,5.25c.23.26,1,1.06.86,0-.13-1.19-.26-4.75.66-5.55s1.06-1.45,2.38-.39,1.19,2,2.51,1.32,1.58-2.12,2.77-1.59.8,3,.8,4.23,0,3.43.79,2.38a3.22,3.22,0,0,0,.35-.72C194.1,128.23,194,126.92,194,125.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.63,
    cy: 206.26,
    r: 11.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,205.48s1.19-1.58,1.46,0-2,3.57-2,3.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,205.48s-1.19-1.58-1.46,0,2,3.57,2,3.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,197.67s-4.48-.35-5.52,2.64-.34,7.82,0,8.74,3.22,5.4,4,5.74,2.76.23,3.11-.23,3.22-4.71,3.44-6.2a54.86,54.86,0,0,0-.12-6.59,4.1,4.1,0,0,0-2.53-3.57A7.68,7.68,0,0,0,189.05,197.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,201.77a4.1,4.1,0,0,0-2.53-3.57,7.68,7.68,0,0,0-2.4-.53s-4.48-.35-5.52,2.64a14.71,14.71,0,0,0-.51,5.25c.23.26,1,1.07.86.05-.13-1.18-.26-4.75.66-5.54s1.06-1.46,2.38-.4,1.19,2,2.51,1.32,1.58-2.11,2.77-1.58.8,3,.8,4.22,0,3.44.79,2.38a3.34,3.34,0,0,0,.35-.71C194.1,204.09,194,202.78,194,201.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,200.07a7.07,7.07,0,0,0,9.44,1.7s1.42,0,1.42-1.7.5-1-2-1S185.2,194.52,184.54,200.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,206.22H184l.47,1.47a.69.69,0,0,0,.66.47h2.29a.69.69,0,0,0,.67-.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,206.22h-4.45l.47,1.47a.7.7,0,0,0,.66.47h2.3a.67.67,0,0,0,.66-.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.38,
    y1: 147.36,
    x2: 195.96,
    y2: 147.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.38,
    y1: 184.63,
    x2: 195.96,
    y2: 184.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.38,
    y1: 221.91,
    x2: 195.96,
    y2: 221.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85,294.83s0-3.47-4.85-8.33-8-7.63-8-7.63-2.43,8,2.08,12.84A85.76,85.76,0,0,0,85,301.07Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,316.49s0-3.47-4.85-8.32-8-7.64-8-7.64-2.43,8,2.08,12.84A85.76,85.76,0,0,0,78,322.73Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.72,300.74s.36-3.45,5.71-7.77,8.73-6.74,8.73-6.74,1.58,8.19-3.42,12.54a85.45,85.45,0,0,1-11.68,8.17Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,326.32s.73-3.39,6.5-7.12,9.4-5.79,9.4-5.79.7,8.31-4.73,12.11a85.74,85.74,0,0,1-12.47,6.9Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8,354.21s0-3.47,4.86-8.32,8-7.64,8-7.64,2.43,8-2.08,12.84a85.49,85.49,0,0,1-10.76,9.36Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.72,361s.5-3.44-3.62-8.93-6.81-8.69-6.81-8.69-3.54,7.55.23,13a85.56,85.56,0,0,0,9.32,10.8Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,381.2s0-3.47,4.86-8.33,8-7.63,8-7.63,2.43,8-2.08,12.83a85.06,85.06,0,0,1-10.76,9.37Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,399.49s-.88-3.36,2.59-9.28,5.78-9.41,5.78-9.41,4.37,7.11,1.24,12.94a85.38,85.38,0,0,1-8,11.79Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,293.94a96.63,96.63,0,0,1-1.33,10.77C82.21,314.63,77.41,321,75.49,330s3.6,20.5,2.12,32-6,17.9-4.68,25.58,8,28.47,8,28.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.67,
    y1: 303.04,
    x2: 89.9,
    y2: 299.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.91,
    y1: 298.42,
    x2: 82.72,
    y2: 294.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.78,329.57s4.39-3.28,8.89-6.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,322.73a70.27,70.27,0,0,0-7.78-11.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,359.14a54,54,0,0,1,9.37-12.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,364a61.49,61.49,0,0,0-4.74-9c-2.56-3.78-2.92-4.26-2.92-4.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,387.57a58.62,58.62,0,0,1,3.95-8A50.84,50.84,0,0,1,82,372.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,405.53a14.9,14.9,0,0,1,1.31-7.68c1.83-3.53,3.9-8.16,4.75-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.22,341.17s-.37-2.18,2.14-5.75,4.18-5.65,4.18-5.65,2.39,4.74.09,8.27a53.7,53.7,0,0,1-5.73,7Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,354s-.37-2.17,2.15-5.74,4.17-5.65,4.17-5.65,2.39,4.74.09,8.27a54.49,54.49,0,0,1-5.73,7Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,344.84s-.61-2.13-4.43-4.25-6.21-3.28-6.21-3.28-.1,5.3,3.51,7.49a54.22,54.22,0,0,0,8.21,3.86Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.17,360s-.82-2-4.84-3.77-6.52-2.61-6.52-2.61.46,5.29,4.27,7.09a54.81,54.81,0,0,0,8.58,3Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2,377.62s-.38-2.18-4-4.69S54.42,369,54.42,369s-.66,5.26,2.69,7.82a53.84,53.84,0,0,0,7.76,4.7Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,381.88s-.69-2.1,1.3-6,3.33-6.19,3.33-6.19,3,4.35,1.26,8.18a54,54,0,0,1-4.67,7.78Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.08,399.42s.25-2.19,3.68-4.91,5.59-4.24,5.59-4.24,1,5.22-2.24,8a55,55,0,0,1-7.48,5.14Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.18,394s-.38-2.17-4-4.69-5.83-3.92-5.83-3.92-.66,5.27,2.7,7.82a53.79,53.79,0,0,0,7.76,4.71Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13,405.84s.19-2.2-2.63-5.54S62.85,395,62.85,395s-2,4.93.63,8.25a54.6,54.6,0,0,0,6.32,6.52Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85,340.66a63.91,63.91,0,0,0,2,6.61c2.28,6,6,9.5,8.16,14.91s0,13.24,2.15,20.3,5.68,10.58,5.71,15.53S69,416.73,69,416.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.34,
    y1: 346.28,
    x2: 50.62,
    y2: 344.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.68,
    y1: 343.4,
    x2: 54.63,
    y2: 340.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79,362s-3.11-1.58-6.29-3.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67,357.9a44.48,44.48,0,0,1,3.59-8.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,380.73a34.62,34.62,0,0,0-7.23-6.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,383.69a38.18,38.18,0,0,1,2-6.16c1.19-2.64,1.37-3,1.37-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7,401.77a32.88,32.88,0,0,1,4-4.15,21.79,21.79,0,0,0,2.6-2.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,398a36.9,36.9,0,0,0-3.34-4.58,33.22,33.22,0,0,0-3.93-3.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,409.8a9.45,9.45,0,0,0-1.66-4.68c-1.53-2-3.33-4.69-4.06-5.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,414.33H90.79a0,0,0,0,1,0,0v23.29a3,3,0,0,1-3,3H62.07a3,3,0,0,1-3-3V414.33A0,0,0,0,1,59,414.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,418.48H59A2.49,2.49,0,0,1,56.54,416h0A2.49,2.49,0,0,1,59,413.5H90.52A2.49,2.49,0,0,1,93,416h0A2.49,2.49,0,0,1,90.52,418.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.07,302.83H340c-3.65,0-3.78.44-3.78,3.76v65.07h56.61V306.59C392.85,303.27,392.72,302.83,389.07,302.83Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.69,
    y: 389.97,
    width: 4.54,
    height: 36.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 397.12,
    width: 9.99,
    height: 30.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.06,
    y: 381.79,
    width: 31.79,
    height: 10.9,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.34,
    cy: 438.78,
    r: 2.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,438.78a2.22,2.22,0,1,0-2.22,2.22A2.22,2.22,0,0,0,398.79,438.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.96 427.54 328.86 434.73 328.86 436.82 363.6 433.95 363.6 427.41 358.96 427.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.95 427.54 399.06 434.73 399.06 436.82 364.31 433.95 364.31 427.41 368.95 427.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,441h0a1.61,1.61,0,0,1-1.61-1.61v-6.7a1.62,1.62,0,0,1,1.61-1.62h0a1.62,1.62,0,0,1,1.61,1.62v6.7A1.61,1.61,0,0,1,364.08,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.69,
    y: 427.41,
    width: 4.79,
    height: 9.93,
    transform: "translate(728.16 864.75) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.42,
    y: 366.86,
    width: 62.06,
    height: 16.05,
    rx: 2.25,
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.13 345.43 343.41 352.92 353.38 366.57 381.79 366.57 388.51 355.07 385.21 345.43 347.13 345.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.41,352.92s-5.51,3.46-6.8,9.13c-.63,2.78,4.85,12.55,8,13.6,3,1,19.84-10.92,19.84-10.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.66,355.83s-6.5-1-8.12,3.69c-1.13,3.29.35,13,.72,14.11s6.66,55,6.66,55h8.86l3-68",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,428.63l-1,4.13-9.72,5.83s.31,1.84,1.78,1.84h16.84A2.14,2.14,0,0,0,354,438l-1.18-9.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,438.72c.1.41.51,1.71,1.75,1.71h16.84a2.13,2.13,0,0,0,2.08-1.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,432.76a27,27,0,0,1,7.06.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.49,
    y1: 436.59,
    x2: 346.65,
    y2: 440.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,352.92s5.51,3.46,6.8,9.13c.63,2.78-4.85,12.55-8,13.6-3,1-19.84-10.92-19.84-10.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.71,355.83s6.5-1,8.12,3.69c1.13,3.29-.35,13-.72,14.11s-6.66,55-6.66,55h-8.86l-2.95-68",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.45,428.63l1,4.13,9.72,5.83s-.31,1.84-1.78,1.84H378.53a2.14,2.14,0,0,1-2.12-2.39l1.18-9.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.12,438.72c-.1.41-.51,1.71-1.75,1.71H378.53a2.13,2.13,0,0,1-2.08-1.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,432.76a27,27,0,0,0-7.06.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.88,
    y1: 436.59,
    x2: 383.72,
    y2: 440.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.52 286.25 370.41 286.81 360.44 286.55 359.38 287.47 359.38 286.81 358.27 286.25 338.35 295.52 347.13 345.43 385.21 345.43 391.26 295.52 371.52 286.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.74,284.49s-4.09,2.75-4.09,3.61-.58,10-.58,10l5.16-1.72,7,6,6.8-5.74,6.31,1.44-2-10.61-7.74-5.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.26 295.52 408.68 325.05 395.63 326.55 388.73 316.92 391.26 295.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.54 295.52 321.22 325.05 334.27 326.55 344.22 315.35 338.54 295.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.59 290.62 365.2 302.44 357.97 290.62 357.97 273.38 372.59 273.38 372.59 290.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.38,268.8s-2.71-.71-2.44,1.19,1.09,5.43,2.44,6.24l1.36.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,268.8s2.71-.71,2.44,1.19-1.09,5.43-2.44,6.24l-1.36.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.81,265.65a10.31,10.31,0,0,0-20.61,0,10.54,10.54,0,0,0,.49,3.15l2.63,12.34,4.79,6.72h4.62l4.65-5.85,2.84-12.92A10.27,10.27,0,0,0,375.81,265.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,264.84a13,13,0,0,0-1.09,4.07,18.71,18.71,0,0,0,1.36,4.88s3.25-6.78,3-9.22S373.32,264,373.6,264.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.51,273.25s0-.43.07-1.06c.15-1.75.56-5.13,1.56-5.72,1.35-.82,1.21-5.1,1.21-5.1s-1.89,2.14,4.62,4.31,11.79,1.33,15.32-3.28.27-7.87-.27-6.24-1.63,3.8-3.53,2.17-4.88-4.88-10.3-4.88-7.87,4.88-7.87,4.88a5.33,5.33,0,0,0-3,4.61C354.34,266.19,356.51,273.25,356.51,273.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.59,264.66c-3.84.16-7.11-2.43-10.44-4.71s-5.6,0-5.6,0a5.76,5.76,0,0,1,5.31-4.57c4.53-.29,6,5.93,10.23,6.47",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.77,273h-9.08l1,3a1.39,1.39,0,0,0,1.33,1h4.69a1.41,1.41,0,0,0,1.36-1.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,273h-9.07l1,3a1.41,1.41,0,0,0,1.34,1h4.69a1.41,1.41,0,0,0,1.36-1.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.69,
    y1: 273.02,
    x2: 355.23,
    y2: 268.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.83,
    y1: 273.02,
    x2: 375.87,
    y2: 268.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.77,
    y1: 273.02,
    x2: 365.76,
    y2: 273.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.52,
    y1: 274.43,
    x2: 366.12,
    y2: 274.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,280.16s-.68,1-1.49,1-1.49-1-1.49-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.58,322.88s-3.79-3.31-4.75-3-2.08,4.47-1.26,5.53,2.63-2.56,2.63-2.56l3.41,4.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,324.35l-3.51,1.26a9.53,9.53,0,0,1-2.94,2.39c-1.61.71-2.43,1.47-.65,2.25s4.34-2,4.34-2l4,.41A3.09,3.09,0,0,0,374,324.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.44,331.11a5.35,5.35,0,0,0,3.5.59c1.94-.36,5.06-4.41,5.06-4.41l-1.57-2.9-6-.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.17,321.44s-2.22,5.81-1.95,6.76,4,3.25,5.22,2.91c.79-.22,2.41-2.24,3.45-3.6a1.58,1.58,0,0,0-.3-2.2C378.66,323.84,375,321.2,374.17,321.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.02,
    y1: 329.59,
    x2: 376.75,
    y2: 322.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.6,
    y1: 325.03,
    x2: 375.84,
    y2: 330.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.81,324.1h0a14.52,14.52,0,0,1,.85,7.49l-.05.28,23.47,2a4.47,4.47,0,0,0,3.85-4.52l0-1.73a4.47,4.47,0,0,0-4.7-4.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44,322.88s3.78-3.31,4.74-3,2.09,4.47,1.27,5.53-2.63-2.56-2.63-2.56l-3.42,4.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.05,324.35l3.52,1.26a9.39,9.39,0,0,0,2.94,2.39c1.6.71,2.42,1.47.65,2.25s-4.34-2-4.34-2l-4,.41A3.1,3.1,0,0,1,349.05,324.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,331.11a5.35,5.35,0,0,1-3.5.59c-1.94-.36-5.06-4.41-5.06-4.41l1.57-2.9,6-.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.85,321.44s2.22,5.81,1.94,6.76-4,3.25-5.22,2.91c-.78-.22-2.41-2.24-3.44-3.6a1.58,1.58,0,0,1,.3-2.2C344.35,323.84,348,321.2,348.85,321.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.99,
    y1: 329.59,
    x2: 346.26,
    y2: 322.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.42,
    y1: 325.03,
    x2: 347.18,
    y2: 330.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2,324.1h0a19.05,19.05,0,0,0-.63,7.49l0,.28-17.71,2c-1.69-.32-2.94-2.25-2.91-4.52l0-1.73c0-2.53,1.64-4.51,3.54-4.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.47,
    y: 328.37,
    width: 53,
    height: 1.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.63,
    y: 328.57,
    width: 26.42,
    height: 1.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.44,
    y: 278.36,
    width: 61.63,
    height: 39.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.22,
    y: 278.36,
    width: 59.85,
    height: 39.74,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.82,
    y: 296.68,
    width: 14.96,
    height: 34.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.2,
    y: 296.68,
    width: 14.96,
    height: 34.04,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "398.21 297.08 414.51 297.08 414.51 320.39",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.79,
    y: 318.65,
    width: 11.08,
    height: 12.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 281.44,
    width: 51.47,
    height: 38.6,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 283.46,
    width: 46.09,
    height: 34.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "243.88 380.33 254.45 427.15 259.25 425.81 258.93 378.32 243.88 380.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.45 427.15 248.05 438.56 246.76 440.91 253.81 440.91 259.25 433.19 259.25 440.58 261.62 440.58 261.62 428.16 259.25 425.81 254.45 427.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.71 380.33 273.14 427.15 268.34 425.81 268.66 378.32 283.71 380.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.14 427.15 279.55 438.56 280.83 440.91 273.78 440.91 268.34 433.19 268.34 440.58 265.98 440.58 265.98 428.16 268.34 425.81 273.14 427.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.84,
    y: 322.32,
    width: 11.22,
    height: 13.03,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.56,364.73a13.46,13.46,0,1,1-13.46-13.46A13.46,13.46,0,0,1,262.56,364.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.83,364.73a13.46,13.46,0,1,0,13.46-13.46A13.46,13.46,0,0,0,263.83,364.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.64,281.49l.67,7.93,7.6.66.33-7.6S261,278.51,258.64,281.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,290.1a8.69,8.69,0,0,1,5.74-2.53c3.95-.37,9.93-.15,12.06,1.31a13.5,13.5,0,0,1,3.52,3.88l-24.09-.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.09,297.62c-2.57-2.92-5.4-5.08-8.43-5.34-9.23-.81-19.15-2.25-28.49-.17-3.82.84-8,2-11,4.57s-4,6.46-6.11,9.76l-6.8,10.84Q223,324,218.76,330.82s-1.22,3.66,3.35,5.49,7.32-.92,7.32-.92L240.23,319l3.48,31.45h37.81l4-34.59c1.29,2.32,11.7,20.77,15.43,21.1,4,.37,6.15-.72,7.59-4.7,1.6-4.41-7.56-15.05-9.76-18.32C296.22,310.06,292.54,302.69,288.09,297.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,295.22l12.37,18.41-16.77,8.25-39.86.55-15.67-13.19,10.45-14.85s9.35-4.67,25-4.95S288.78,295.22,288.78,295.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,350.41l-2.86,11.46a8.47,8.47,0,0,0,.7,5.95l5.38,10.37h32.79l5.19-9.69a9.84,9.84,0,0,0,.48-8.25l-3.87-9.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.75,
    y: 370.93,
    width: 6.86,
    height: 26.17,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 392.98,
    width: 10.34,
    height: 35.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.13 427.61 264.34 426.32 264.34 426.09 263.9 426.2 263.47 426.09 263.47 426.32 258.68 427.61 226.02 433.71 226.02 436.1 263.47 436.1 264.34 436.1 301.79 436.1 301.79 433.71 269.13 427.61",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.85,
    cy: 437.63,
    r: 2.29,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,437.63a2.29,2.29,0,1,1-2.29-2.29A2.28,2.28,0,0,1,266.19,437.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,437.63a2.29,2.29,0,1,1-2.28-2.29A2.28,2.28,0,0,1,301.46,437.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,379.2h-42a8.89,8.89,0,0,1-8.9-8.9l5-62.84a7.42,7.42,0,0,1,7.41-7.42h35a7.41,7.41,0,0,1,7.41,7.42l5,62.84A8.89,8.89,0,0,1,285.19,379.2Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,382.51h-42a8.89,8.89,0,0,1-8.9-8.9l5-62.84a7.42,7.42,0,0,1,7.41-7.42h35a7.41,7.41,0,0,1,7.41,7.42l5,62.84A8.89,8.89,0,0,1,285.19,382.51Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,285.85h0a7.82,7.82,0,0,1-7.69-6.41c-.23-1.28-.42-2.56-.75-3.82l-1.71-9.13a10.16,10.16,0,0,1,10.15-10.16h0a10.16,10.16,0,0,1,10.16,10.16l-1.71,9.13c-.33,1.26-.52,2.54-.75,3.82A7.82,7.82,0,0,1,262.78,285.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,258.4a8.43,8.43,0,0,0-5.15,7.05c-.41,5.28,1.22,11.11,1.49,14.91s-.95,6.78-4.2,11.93-1.22,12.74,6.64,16.94,18.37,1.65,21.83-2.71c6.53-8.24-1.9-19.38-3-25.21s1.49-13.42-1.62-19.25-7.32-7.73-10.85-7.73S256.45,258.4,256.45,258.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.84,275.15s-1.65,10.72.82,19-1.37,15.94-10.45,16.21-11.27-11.54-6.32-11.82,4.95,4.95,3.85,5.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,258.4s4.29,3,4.57,7.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.38,
    y: 317.59,
    width: 11.99,
    height: 13.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.76,
    y: 277.31,
    width: 55.71,
    height: 41.78,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.67,
    y: 279.5,
    width: 49.88,
    height: 37.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.67,
    y: 328.81,
    width: 52.21,
    height: 2.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.5 440.56 85.75 440.56 83.76 333.6 90.48 333.6 88.5 440.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.71 440.56 108.96 440.56 106.97 333.6 113.7 333.6 111.71 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.68 440.56 277.93 440.56 275.94 333.6 282.67 333.6 280.68 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.5 440.56 307.74 440.56 305.76 333.6 312.48 333.6 310.5 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.01 440.56 299.26 440.56 297.27 333.6 304 333.6 302.01 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.67 440.56 405.92 440.56 403.93 333.6 410.65 333.6 408.67 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.58 440.56 137.82 440.56 135.84 333.6 142.56 333.6 140.58 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.42 440.56 158.67 440.56 156.68 333.6 163.41 333.6 161.42 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.46 440.56 412.7 440.56 410.72 333.6 417.44 333.6 415.46 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.36 440.56 422.61 440.56 420.62 333.6 427.35 333.6 425.36 440.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.77 440.56 267.02 440.56 265.04 333.6 271.76 333.6 269.77 440.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.73 440.56 432.98 440.56 430.99 333.6 437.71 333.6 435.73 440.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 330.44,
    width: 362.19,
    height: 27.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 330.44,
    width: 362.19,
    height: 7.03,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.79,
    y: 330.44,
    width: 367.26,
    height: 3.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.58,427.46l-8.5,10.76s-1.41,1.7,1.13,2,15.3,0,15.3,0l-.41-10.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,362.92l-.5,66.13a3.16,3.16,0,0,0,3.16,3.18H124a3.17,3.17,0,0,0,3.12-2.66l9.51-60.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.21,
    cy: 362.92,
    r: 14.39,
    transform: "translate(-250.67 408.63) rotate(-76.63)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,427.46l8.49,10.76s1.42,1.7-1.13,2-15.29,0-15.29,0l.39-11.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,362.92l.5,66.13a3.16,3.16,0,0,1-3.16,3.18h-2.49a3.15,3.15,0,0,1-3.12-2.66L160,369.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.35,
    cy: 362.92,
    r: 14.39,
    transform: "translate(-208.78 221.8) rotate(-45)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,273.94l.7,8.48,8.13.7.35-8.12S145.89,270.76,143.42,273.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,271.72h0a1.68,1.68,0,0,1-1.86-1.47l-.53-4.48a1.68,1.68,0,0,1,1.48-1.86h0a1.68,1.68,0,0,1,1.86,1.47l.53,4.47A1.68,1.68,0,0,1,139.34,271.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,271.15h0a1.68,1.68,0,0,1-1.53-1.81l.37-4.49a1.68,1.68,0,0,1,1.82-1.54h0a1.68,1.68,0,0,1,1.53,1.82l-.37,4.49A1.68,1.68,0,0,1,156.51,271.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84,278.6h0a8.36,8.36,0,0,1-8.22-6.85c-.25-1.37-.45-2.74-.8-4.08L137,257.9a10.85,10.85,0,0,1,10.85-10.85h0A10.86,10.86,0,0,1,158.7,257.9l-1.83,9.77c-.35,1.34-.56,2.71-.8,4.08A8.36,8.36,0,0,1,147.84,278.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,283.42a9.28,9.28,0,0,1,6.13-2.71c4.22-.39,11.24-1.39,13.51.17a83.09,83.09,0,0,1,7,6.07l-29.56-1.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,287.34l-21,39.33s-1.3,3.91,3.59,5.86,7.82-1,7.82-1l12.33-18.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,286.07s27.13,37.84,25.59,42.1-3.87,5.41-8.12,5S172,310.38,172,310.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85,285.74s-16.95-1.63-26.4-1.63-20.64,3.23-20.64,3.23l5.64,60.27h40.42l3.32-61.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,347.61l-3,12.25a9.05,9.05,0,0,0,.75,6.36l5.74,11.09h35.05L171.49,367a10.52,10.52,0,0,0,.52-8.82l-4.14-10.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.66,
    y: 369.54,
    width: 7.33,
    height: 27.97,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.8,
    y: 393.12,
    width: 11.06,
    height: 35.38,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.63 427.56 149.5 426.19 149.5 425.94 149.04 426.06 148.57 425.94 148.57 426.19 143.45 427.56 108.54 434.08 108.54 436.64 148.57 436.64 149.5 436.64 189.54 436.64 189.54 434.08 154.63 427.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.57,
    cy: 438.27,
    r: 2.44,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.48,438.27a2.44,2.44,0,1,1-2.44-2.44A2.44,2.44,0,0,1,151.48,438.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.19,438.27a2.45,2.45,0,1,1-2.45-2.44A2.45,2.45,0,0,1,189.19,438.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,342.72h7.25a0,0,0,0,1,0,0v31.43a0,0,0,0,1,0,0h-.26a7,7,0,0,1-7-7V342.72A0,0,0,0,1,114,342.72Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.82,
    y: 336.16,
    width: 11.4,
    height: 5.87,
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,374.15h0A7.24,7.24,0,0,0,185,366.9V342.72H177.7Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.7,
    y: 336.16,
    width: 11.4,
    height: 5.87,
    transform: "translate(366.8 678.2) rotate(180)",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,378.39H126.87a9.51,9.51,0,0,1-9.52-9.51l5.33-67.18a7.93,7.93,0,0,1,7.93-7.93h37.44A7.93,7.93,0,0,1,176,301.7l5.33,67.18A9.51,9.51,0,0,1,171.8,378.39Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,381.92H126.87a9.51,9.51,0,0,1-9.52-9.51l5.33-67.18a7.93,7.93,0,0,1,7.93-7.92h37.44a7.93,7.93,0,0,1,7.93,7.92l5.33,67.18A9.51,9.51,0,0,1,171.8,381.92Z",
    style: {
      fill: "#1473E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInteractions);
export default __webpack_public_path__ + "static/media/No-interactions.f8ca29a591bf37c735b51f2e648ba0fb.svg";
export { ForwardRef as ReactComponent };